/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendUserRetrieveUpdateDto } from '../../models/backend-user-retrieve-update-dto';
import { BackendUserRetrieveUpdateRequestDto } from '../../models/backend-user-retrieve-update-request-dto';

export interface AccountMeUpdate$FormData$Params {
  body: BackendUserRetrieveUpdateRequestDto;
}

export function accountMeUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccountMeUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
  const rb = new RequestBuilder(rootUrl, accountMeUpdate$FormData.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserRetrieveUpdateDto>;
    }),
  );
}

accountMeUpdate$FormData.PATH = '/api/account/me/';
